<template>
  <div class="text-right chart-controls flex-row">
    <mf-tooltip bottom>
      <template #activator="{ on }">
        <mf-button icon="first_page" type="icon" color="cinza-0" size="sm" @click="navigate('firstPosition')" />
      </template>
      <span>Início</span>
    </mf-tooltip>

    <mf-tooltip bottom>
      <template #activator="{ on }">
        <mf-button
          icon="chevron_left"
          type="icon"
          color="cinza-0"
          size="sm"
          @click="navigate('fastNavigateLeft')"
          @mouseup="clickAndHoldStop"
          @mouseleave="clickAndHoldStop"
        />
      </template>
      <span>{{ interval }} para a esquerda</span>
    </mf-tooltip>

    <mf-tooltip bottom>
      <template #activator="{ on }">
        <mf-button
          icon="arrow_left"
          type="icon"
          color="cinza-0"
          size="sm"
          @click="navigate('navigateLeft')"
          @mouseup="clickAndHoldStop"
          @mouseleave="clickAndHoldStop"
        />
      </template>
      <span>1 para a esquerda</span>
    </mf-tooltip>

    <v-container :class="this.metricsPeriod === 'MONTHLY' ? 'ma-0 pa-0 chart-date monthly' : 'ma-0 pa-0 chart-date yearly'">
      <span style="display: inline-block">{{ selectedPeriod }}</span>
    </v-container>

    <mf-tooltip bottom>
      <template #activator="{ on }">
        <mf-button
          icon="arrow_right"
          type="icon"
          color="cinza-0"
          size="sm"
          @click="navigate('navigateRight')"
          @mouseup="clickAndHoldStop"
          @mouseleave="clickAndHoldStop"
        />
      </template>
      <span>1 para a direita</span>
    </mf-tooltip>

    <mf-tooltip bottom>
      <template #activator="{ on }">
        <mf-button
          icon="chevron_right"
          type="icon"
          color="cinza-0"
          size="sm"
          @click="navigate('fastNavigateRight')"
          @mouseup="clickAndHoldStop"
          @mouseleave="clickAndHoldStop"
        />
      </template>
      <span>{{ interval }} para a direita</span>
    </mf-tooltip>

    <mf-tooltip bottom>
      <template #activator="{ on }">
        <mf-button icon="last_page" type="icon" color="cinza-0" size="sm" @click="navigate('lastPosition')" />
      </template>
      <span>Final</span>
    </mf-tooltip>
    <span class="ml-4 pr-2">{{ metricsLength + 1 - chartIndex }}/{{ metricsLength + 1 }}</span>
  </div>
</template>

<script>
export default {
  name: 'ChartNavigator',
  props: {
    selectedPeriod: String,
    chartIndex: Number,
    metricsLength: Number,
    metricsPeriod: String,
  },
  computed: {
    interval() {
      return this.metricsPeriod === 'MONTHLY' ? 12 : 2
    },
  },
  methods: {
    navigate(navigationType) {
      let newChartIndex
      switch (navigationType) {
        case 'navigateLeft':
          newChartIndex = this.chartIndex + 1
          break
        case 'fastNavigateLeft':
          newChartIndex = this.metricsPeriod === 'MONTHLY' ? this.chartIndex + 12 : this.chartIndex + 2
          if (newChartIndex > this.metricsLength) newChartIndex = this.metricsLength
          break
        case 'firstPosition':
          newChartIndex = this.metricsLength
          break
        case 'navigateRight':
          newChartIndex = this.chartIndex - 1
          break
        case 'fastNavigateRight':
          newChartIndex = this.metricsPeriod === 'MONTHLY' ? this.chartIndex - 12 : this.chartIndex - 2
          if (newChartIndex < 0) newChartIndex = 0
          break
        case 'lastPosition':
          newChartIndex = 0
          break
        default:
          console.log(navigationType)
      }
      if (newChartIndex < 0 || newChartIndex > this.metricsLength) return
      this.$emit('navigateTo', newChartIndex)
    },
    clickAndHoldStart(method) {
      this[method]()
      this.timeout = setTimeout(() => {
        this.clickAndHoldStart(method)
      }, 100)
    },
    clickAndHoldStop() {
      clearTimeout(this.timeout)
    },
  },
}
</script>

<style scoped>
.chart-controls {
  user-select: none;
}
.chart-date {
  display: inline-block;
  text-align: center;
  transition: all 0.3s;
}
.monthly {
  width: 140px;
}
.yearly {
  width: 80px;
}
</style>
